import { DateTime } from 'luxon'

import { getStaticImage } from 'utils/statics'
import flagEnvDisplay from 'constants/flagEnvDisplay'

export const navbarOptions = [
  {
    type: 'all',
    iconUrl: getStaticImage('/icons/orange-brand/icon-asterisk-grey.svg'),
    activeIconUrl: getStaticImage('/icons/orange-brand/icon-asterisk-dark.svg'),
    title: 'dashboard_all'
  },
  {
    type: 'messages',
    iconUrl: getStaticImage('/icons/orange-brand/icon-chat-grey.svg'),
    activeIconUrl: getStaticImage('/icons/orange-brand/icon-chat-dark.svg'),
    title: 'dashboard_messages'
  },
  {
    type: 'people',
    iconUrl: getStaticImage('/icons/orange-brand/icon-user-slim-grey.svg'),
    activeIconUrl: getStaticImage('/icons/orange-brand/icon-user-slim-dark.svg'),
    title: 'dashboard_people'
  },
  {
    type: 'chatmail',
    iconUrl: getStaticImage('/icons/orange-brand/icon-at-sign-grey.svg'),
    activeIconUrl: getStaticImage('/icons/orange-brand/icon-at-sign-dark.svg'),
    title: 'ChatMail'
  },
  {
    type: 'campaigns',
    iconUrl: getStaticImage('/icons/orange-brand/icon-campaign-grey.svg'),
    activeIconUrl: getStaticImage('/icons/orange-brand/icon-campaign-dark.svg'),
    title: 'dashboard_campaigns'
  },
  ...flagEnvDisplay.displayGlobalSearchSmartchat
    ? [{
      type: 'smartchat',
      iconUrl: getStaticImage('/icons/orange-brand/icon-automation-grey.svg'),
      activeIconUrl: getStaticImage('/icons/orange-brand/icon-automation-dark.svg'),
      title: 'SmartChat'
    }]
    : []
]

export const getParsedDate = dateISOString => {
  let date = ''
  let time = ''
  if (dateISOString) {
    date = DateTime.fromISO(dateISOString).setLocale('es-ES').toFormat('DD')
    time = DateTime.fromISO(dateISOString).setLocale('es-ES').toFormat('T')
  }
  return { date, time }
}
